import axios from '../../http.js';
const UPLOAD_URL = 'api/storage/upload/multiFile';
export const MATERIAL_UPLOAD = UPLOAD_URL;
export default {
    uploadFileByBase64 (fileStr) {
        const url = 'api/storage/upload/base64';
        return axios.post(url, {fileStr});
    },
    uploadFile (formData, progressCallback) {
        const url = UPLOAD_URL;
        return axios.post(url, formData, {
            headers: {'Content-Type': 'multipart/form-data'},
            onUploadProgress: progressEvent => {
                var complete = (progressEvent.loaded / progressEvent.total * 100 | 0);
                progressCallback && progressCallback(complete);
            }
        });
    },
    downloadImg (url) {
        return axios({
            method: 'get',
            url: url,
            responseType: 'blob',
        })
    },
}